import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  ColorNamesColorPresetModel,
  BlockTypes,
} from "../../models/BlockTransportSystemJsonModel";
import ColorNamesPresetView from "../Presets/ColorNamesPresetView";
import GraphicNamesPresetView from "../Presets/GraphicNamesPresetView";
import GraphicNames12CutPresetView from "../Presets/GraphicNames12CutPresetView";
import { Button, Modal, Stack } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const Content = styled.div`
  width: 100%;
  height: 500px;
  flex-direction: row;
  display: flex;
  -webkit-column-count: 3;
  -moz-column-count: 3;
  column-count: 3;
  column-gap: 2em;
  -webkit-column-gap: 2em;
  -moz-column-gap: 2em;
`;

const Partition = styled.div`
  height: 100%;
  width: 50%;
  padding: 10px;
  display: inline-block;
`;

const TextColorInput = styled.input`
  width: 100px;
  margin: 5px;
  :invalid {
    border: 2px solid red;
  }
`;

interface Props {
  onClickCancel?: (e?: React.MouseEvent<HTMLElement>) => void;
  onClickCreate?: (preset: ColorNamesColorPresetModel) => void;
  presetEditModel?: ColorNamesColorPresetModel;
  blockType: BlockTypes;
  presetLength: number;
  isShow: boolean;
}

const ModalTextColorPreset = ({
  onClickCancel,
  onClickCreate,
  presetEditModel,
  blockType,
  presetLength,
  isShow
}: Props) => {
  const { t } = useTranslation();
  const [currentPresetLength, setCurrentPresetLength] = useState(presetEditModel?.textColorPresets?.length ?? presetLength);
  const [model, setModel] = useState<ColorNamesColorPresetModel>(
    {
      presetName: "기본 색상",
      textColorPresets: new Array(currentPresetLength).fill("000000"),
    }
  );
  const [applyAll, setApplyAll] = useState("");

  useEffect(() => {
    if (presetEditModel) {
        setModel(getDisplayModel(presetEditModel));
    }
  }, []);

  const getDisplayModel = (model: ColorNamesColorPresetModel): ColorNamesColorPresetModel => {
    return {
      ...model,
      textColorPresets: model.textColorPresets.map((element) => {
        return element.replace("#", "");
      }),
    }
  }

  const getDataModel = (model: ColorNamesColorPresetModel): ColorNamesColorPresetModel => {
    return {
      ...model,
      textColorPresets: model?.textColorPresets?.map(preset => {
        return preset.indexOf("#") < 0 ? `#${preset}` : preset;
      })
    }
  }

  const verifyPresetModel = (model: ColorNamesColorPresetModel): boolean => {
    if(model.textColorPresets.length !== presetLength && presetLength > 0) {
      alert(`색상 프리셋의 길이는 ${presetLength}이어야 합니다.`);
      return false;
    }
    if (
      model.textColorPresets.some((text, index) => {
        const regexResult = /^([0-9a-fA-F]{3}){1,2}$/.test(text);
        if (!regexResult) {
          alert(
            `${index +
              1} 번째 텍스트\n색상이 비어있거나, 16진수 3자리 혹은 6자리가 아닌 텍스트가 있습니다.`
          );
        }
        return !regexResult;
      })
    ) {
      return false;
    }

    if (model.presetName == "") {
      alert(`프리셋 이름을 설정해주세요!`);
      return false;
    }

    return true;
  }

  return (
    <Modal show={isShow} onHide={() => onClickCancel()} size="xl">
      <Modal.Header closeButton>프리셋 설정</Modal.Header>
      <Modal.Body>
        프리셋 이름:
        <TextColorInput
          onChange={(e) => {
            setModel({
              presetName: e.target.value.normalize("NFC"),
              textColorPresets: model.textColorPresets,
            });
          }}
          value={model.presetName}
        />
        {t("button-apply-all")} : #
        <TextColorInput
          type="text"
          onChange={(e) => {
            setApplyAll(e.target.value);
          }}
          pattern="^([0-9a-fA-F]{3}){1,2}$"
        />
        <Stack direction="horizontal" gap={2}>
          <Button
            onClick={() => {
              const newArray = new Array(currentPresetLength).fill(applyAll);
              setModel({
                presetName: model.presetName.normalize("NFC"),
                textColorPresets: newArray,
              });
            }}
          >
            {t("button-apply")}
          </Button>
          <Button
            onClick={() => {
              if (presetLength > 0) {
                alert("프리셋 길이를 조정할 수 없는 제품입니다.");
                return;
              }

              const newArray = [...model.textColorPresets];
              newArray.push("000000");
              setModel({
                presetName: model.presetName.normalize("NFC"),
                textColorPresets: newArray,
              });
            }}
          >
            {t("button-add-color")}
          </Button>
          <Button
            onClick={() => {
              if (presetLength > 0) {
                alert("프리셋 길이를 조정할 수 없는 제품입니다.");
                return;
              }

              const newArray = [...model.textColorPresets];
              setModel({
                presetName: model.presetName.normalize("NFC"),
                textColorPresets:  newArray.slice(0, newArray.length - 1),
              });
            }}
          >
            {t("button-delete-color")}
          </Button>
          <Button onClick={() => {}}
          >
            <label
              htmlFor="selectFile"
            >
              {t("button-import-from-json")}
              <input
                id="selectFile"
                style={{ display: "none" }}
                type="file"
                accept="application/json"
                name="file"
                onChange={(e) => {
                  const reader = new FileReader();
                  reader.onloadend = async () => {
                    const jsonString: string = reader.result.toString();
                    try {
                      const jsonObject = JSON.parse(jsonString) as ColorNamesColorPresetModel;
                      const displayModel = getDisplayModel(jsonObject);
                      if(!verifyPresetModel(displayModel)) {
                        return;
                      }
                      setModel(displayModel);
                    } catch (error) {
                      alert("json파일 형식 혹은 데이터가 잘못되었습니다.");
                    }
                  }
                  reader.readAsText(e.target.files[0]);
                  e.target.value = null;
                }}
              />
            </label>
          </Button>
          <Button
            onClick={() => {
              const presetName = prompt("프리셋 이름을 입력해주세요.")
              const res = prompt("프리셋 색상을 입력해주세요.");
              const colors = res.split("	");
              const model = {
                presetName: presetName,
                textColorPresets: colors
              };
              if(verifyPresetModel(model)) {
                setModel(model);
              }
            }}
          >
            {t("button-import-from-text")}
          </Button>
          <Button
            onClick={() => {
              if(!verifyPresetModel(model)) {
                return;
              }
              var a = document.createElement("a");
              var file = new Blob([JSON.stringify(getDataModel({...model}), null)], {type: "application/json"});
              const url = URL.createObjectURL(file);
              a.href = url;
              a.download = model.presetName;
              a.click();
              URL.revokeObjectURL(url);
            }}
          >
            {t("button-export")}
          </Button>

        </Stack>
        <Content>
          <Partition>
            {blockType === BlockTypes.colorNames &&
              <ColorNamesPresetView
                colors={model.textColorPresets}
                scale={0.23}/>
            }
            {blockType === BlockTypes.graphicNames &&
              <GraphicNamesPresetView
                colors={model.textColorPresets}
                scale={0.2}/>
            }
            {blockType === BlockTypes.graphicNames12cut &&
              <GraphicNames12CutPresetView
                colors={model.textColorPresets}
                scale={0.23}/>
            }
          </Partition>
          <Partition style={{ columnCount: 3 }}>
            {model.textColorPresets.map((text, index) => (
              <div key={index}>
                {index + 1} : #
                <TextColorInput
                  key={index}
                  placeholder={(index + 1).toString()}
                  onChange={(e) => {
                    let temp = model.textColorPresets;
                    temp[index] = e.target.value;
                    setModel({
                      presetName: model.presetName.normalize("NFC"),
                      textColorPresets: temp,
                    });
                  }}
                  value={text}
                />
              </div>
            ))}
          </Partition>
        </Content>
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={() => {
            if(!verifyPresetModel(model)) {
              return;
            }
            onClickCreate(getDataModel({...model}));
          }}
        >
          {`${presetEditModel ? t("button-edit") : t("button-add")}`}
        </Button>
        <Button
          variant="secondary"
          onClick={onClickCancel}
        >
            {t("button-close")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalTextColorPreset;
